<template>
  <div class="loginform">
    <img src="./assets/img/logo.png" alt="" class="logo">
    <div class="box">
        <div class="tit">会员注册</div>
        <div class="app-weui-cells weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
                <div class="weui-cell__bd">
                    <input v-model="tel" class="weui-input" type="tel" placeholder="请输入您的手机号"/>
                </div>
            </div>
            <div class="weui-cell weui-cell_vcode">
                <div class="weui-cell__hd"><label class="weui-label">图形验证码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="captcha" class="weui-input" type="text" placeholder="请输入图形验证码"/>
                </div>
                <img v-if="captcha_info.captcha_url" @click="getcaptcha()" v-bind:src="publics.HOST+captcha_info.captcha_url" alt="" class="imgyzm">
            </div>
            <div class="weui-cell weui-cell_vcode">
                <div class="weui-cell__hd"><label class="weui-label">验证码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="sms_value" class="weui-input" type="tel" placeholder="请输入短信验证码"/>
                </div>
                <div class="weui-cell__ft">
                    <button @click="send()" v-bind:disabled="disabled" class="weui-vcode-btn">{{time}}</button>
                </div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">密码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="password" class="weui-input" type="password" placeholder="请输入您要设置的密码"/>
                </div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">重复密码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="password_re" class="weui-input" type="password" placeholder="请再次输入密码"/>
                </div>
            </div>
            <!-- <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">邀请码</label></div>
                <div class="weui-cell__bd">
                    <input class="weui-input" type="text" placeholder="选填"/>
                </div>
            </div> -->
        </div>
    </div>
    <div class="other">
      <label for="weuiAgree" class="weui-agree fl">
          <input id="weuiAgree" type="checkbox" class="weui-agree__checkbox" v-model="checked"/>
          <span class="weui-agree__text">阅读并同意</span>
      </label>
      <router-link :to="{ name: 'protocol' }" class="fl">《注册协议》</router-link>
      <router-link to="login" class="fr">已有账号？<span class="red">登录</span></router-link>
    </div>

    <div class="app-btn-area weui-btn-area">
        <button @click="submit()" v-bind:disabled="subdisabled" class="weui-btn" :class="[subdisabled?'disabled':'']">注册</button>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return{
        captcha_info:'',
        time: '获取验证码',
        currentTime: 60, // 发送验证码倒计时
        disabled:false, // 发送验证码按钮状态
        tel: "",
        captcha: "",
        sms_value:'',
        password:'',
        password_re:'',
        checked:true
      }
    },
    computed:{
      subdisabled(){
        return !(this.checked && this.tel && this.captcha && this.sms_value && this.password && this.password_re)
      }
    },
    mounted(){
      this.getcaptcha();
    },
    methods:{
      getcaptcha(){
        let vm = this;
        vm.ajax("captcha", "get", '', e => {
          vm.captcha_info = e.data;
        })
      },
      send() {
        let vm = this;
        if(!/^1[2-9]\d{9}$/.test(vm.tel)){
          vm.publics.message.danger('请输入正确的手机号码');
          return false;
        }
        if(!vm.captcha){
          vm.publics.message.danger('请输入正确的图形验证码');
          return false;
        }
        vm.ajax("sms", "post", {
          tel:vm.tel,
          captcha:vm.captcha,
          captcha_id:vm.captcha_info.captcha_id
        }, e => {
          if( e.code != "1000"){
            vm.getcaptcha();
          }
        })
        vm.countdown();
      },
      countdown() {
        let vm = this;
        vm.disabled = true;
        let currentTime = vm.currentTime
        currentTime--;
        vm.time = currentTime + '秒后重发'
        if (currentTime <= 0) {
          vm.time = '重新发送';
          vm.currentTime = 61;
          vm.disabled = false;
          // vm.getcaptcha();
        } else {
          vm.currentTime = currentTime;
          setTimeout(function() {
              vm.countdown()
          }, 1000)
        }
      },
      submit(){
        let vm = this;
        if(!/^1[2-9]\d{9}$/.test(vm.tel)){
          vm.publics.message.danger('请输入正确的手机号码');
          return false;
        }
        if(!vm.sms_value){
          vm.publics.message.danger('请输入手机验证码');
          return false;
        }
        if(!vm.password){
          vm.publics.message.danger('请输入密码');
          return false;
        }
        if(!vm.password_re){
          vm.publics.message.danger('请再次输入密码');
          return false;
        }
        if(vm.password != vm.password_re){
          vm.publics.message.danger('再次输入密码不一致');
          return false;
        }
        vm.ajax("reg", "post", {
          tel:vm.tel,
          sms_value:vm.sms_value,
          password:vm.password,
          password_re:vm.password_re
        }, e => {
          if(e.code == "1000"){
            vm.$router.replace('/')
          }else{
            vm.getcaptcha();
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/register.vue